import ReactDOM from "react-dom";
import { ensureHealthyRpc } from "./utils/rpcUtils";

// 先探测并选定健康的 RPC，再动态加载 Root。
// 这样 wagmi / web3Context 等模块里创建 provider 时，读到的已是选好的健康节点。
ensureHealthyRpc().finally(async () => {
  const { default: Root } = await import("./Root");
  ReactDOM.render(<Root />, document.getElementById("root"));
});
